import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GetTitleService {
  private titleSubject = new BehaviorSubject<string>('Dashboard');
  currentTitle$ = this.titleSubject.asObservable();
  set title(v: string) {
    this.titleSubject.next(v);
  }
  get title() {
    return this.titleSubject.getValue();
  }
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild;
          while (child?.firstChild) {
            child = child.firstChild;
          }
          return child?.snapshot.data['title'] || 'Default Title';
        })
      )
      .subscribe(title => {
        this.title = title;
      });

  }


}
